import { formatFileSize, getFileIcon } from '@/helpers/files';
import { colors } from '@/theme/colors';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { Icon } from '@/ui/icons/icon';
import { Stack } from '@/ui/line/line';
import { SmallText } from '@/ui/typography/action-panel';
import { styled } from 'goober';
import { useTranslation } from 'react-i18next';

interface Props {
  name: string;
  size: number;
  onClose: () => void;
}

export const UploadedFileCard = ({ name, size, onClose }: Props) => {
  const { t } = useTranslation('settings', { keyPrefix: 'feedTab' });

  return (
    <Stack gap="8px">
      <SmallText>{t`articleForm.image`}</SmallText>
      <UploadedImageContainer name="uploaded-file-card">
        <Flexbox gap="12px">
          <Icon icon={getFileIcon(name) ?? 'FileImage'} />
          <Flexbox direction="column">
            <FileName>{name}</FileName>
            <FileSize>{formatFileSize(size)}</FileSize>
          </Flexbox>
        </Flexbox>
        <Flexbox>
          <Icon icon="Close" onClick={onClose} color={colors.system.lowFit} />
        </Flexbox>
      </UploadedImageContainer>
    </Stack>
  );
};

const UploadedImageContainer = styled(Flexbox)`
  height: 56px;
  padding: 6px 12px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;

  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.system.highFit};
  background: ${({ theme }) => theme.colors.blue.c9};
`;

const FileName = styled('p')`
  ${({ theme }) => theme.typography.actionsPanel.acrossPanel.smallText}
  opacity: 1;
`;

const FileSize = styled('p')`
  ${({ theme }) => theme.typography.actionsPanel.acrossPanel.smallText}
  opacity: 1;
  color: ${({ theme }) => theme.colors.gray.c13};
`;
